import { FundraiserSettings } from 'src/modules/fundraiser/models/fundraiserSettings';
import { FundraiserSettingsSearchFilter } from 'src/modules/fundraiser/models/fundraiserSettingsSearchFilter';
import { FundraiserSysSettings } from 'src/modules/fundraiser/models/fundraiserSysSettings';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'FundraiserSetting';

export const getAllFundraiserSettings = (searchFilter: FundraiserSettingsSearchFilter) => {
  return AxiosInstance.get<PagedResult<FundraiserSettings>>(controller, { params: searchFilter });
};

export const getFundraiserSettingsById = (id: string | undefined) => {
  return AxiosInstance.get<FundraiserSettings>(`${controller}/${id}`);
};

export const getFundraiserSysSettings = () => {
  return AxiosInstance.get<FundraiserSysSettings>(`${controller}/SysSetting`);
};
export const updateFundraiserSysSettings = (data: FundraiserSysSettings) => {
  return AxiosInstance.put<FundraiserSysSettings>(`${controller}/SysSetting`, data);
};
